(function () {
  var DEFAULT_INSTAGRAM = 'https://www.instagram.com/gooderawellness/';

  function config(root) {
    if (root && root.getAttribute && root.getAttribute('data-instagram')) {
      return { instagram: root.getAttribute('data-instagram') };
    }
    var el = document.getElementById('ge-social-config');
    if (!el) return { instagram: DEFAULT_INSTAGRAM };
    try {
      var parsed = JSON.parse(el.textContent || '{}');
      return { instagram: (parsed && parsed.instagram) || DEFAULT_INSTAGRAM };
    } catch (e) {
      return { instagram: DEFAULT_INSTAGRAM };
    }
  }

  function loadImages(root) {
    var imgs = root.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var src = img.getAttribute('data-src') || img.getAttribute('src');
      if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
    }
  }

  function addHandle(card, url) {
    if (!url || !card || card.querySelector('.ge-social__handle')) return;
    var a = document.createElement('a');
    a.className = 'ge-social__handle';
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.textContent = '@gooderawellness';
    card.insertBefore(a, card.firstChild);
  }

  function wrapFeed(feed) {
    if (!feed || feed.nodeType !== 1) return null;
    var existing = feed.closest('.ge-social');
    if (existing) {
      loadImages(existing);
      return existing;
    }

    var parent = feed.parentNode;
    if (!parent) return null;

    var root = document.createElement('div');
    root.className = 'ge-social';
    var card = document.createElement('div');
    card.className = 'ge-social__card';
    var host = document.createElement('div');
    host.className = 'ge-social__feed';

    parent.insertBefore(root, feed);
    root.appendChild(card);
    addHandle(card, config(root).instagram);
    card.appendChild(host);
    host.appendChild(feed);
    loadImages(root);
    return root;
  }

  function scan() {
    var feeds = document.querySelectorAll('#insta-feed, .instafeed-shopify');
    for (var i = 0; i < feeds.length; i++) wrapFeed(feeds[i]);
    var roots = document.querySelectorAll('.ge-social');
    for (var r = 0; r < roots.length; r++) {
      loadImages(roots[r]);
      var heading = roots[r].querySelector('.ge-social__heading');
      if (heading) heading.remove();
      var pill = roots[r].querySelector('.ge-social__pill-wrap, .ge-social__pill');
      if (pill && pill.classList.contains('ge-social__pill-wrap')) pill.remove();
      else if (pill && pill.parentNode && pill.parentNode.classList.contains('ge-social__pill-wrap')) {
        pill.parentNode.remove();
      } else if (pill) {
        pill.remove();
      }
      addHandle(roots[r].querySelector('.ge-social__card') || roots[r], config(roots[r]).instagram);
    }
  }

  function boot() {
    scan();
    var observer = new MutationObserver(function () {
      window.requestAnimationFrame(scan);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    [200, 600, 1200, 2400, 4000].forEach(function (ms) {
      window.setTimeout(scan, ms);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
